export default __webpack_public_path__ + "static/media/uploadH.075d2971.png";